// Helper: Size > Convert font size to pixel size
function convertFontSizeToPixelSize (value, { element, willIncludeUnit } = {}) {
	let pixelValue
	switch (typeof(value)) {
		case 'number':
			pixelValue = value
			break
		case 'string':
			const matches = value.match(/^(\d*\.?\d+)(em|px|rem)?$/)
			const number = matches?.[1] ? Number(matches[1]) : null
			const suffix = matches?.[2] || null
			switch (suffix) {
				case 'em':
					if (element instanceof HTMLElement) {
						const elementFontSize = parseFloat(window.getComputedStyle(element)?.fontSize)
						if (!Number.isNaN(elementFontSize)) pixelValue = elementFontSize * number
					}
					break
				case 'px':
					pixelValue = number
					break
				case 'rem':
					const baseFontSize = parseFloat(window.getComputedStyle(document.documentElement)?.fontSize)
					if (!Number.isNaN(baseFontSize)) pixelValue = baseFontSize * number
					break
				default:
					const isStartingWithDot = String(value).startsWith('.')
					if (value === String(Number(value)) || (isStartingWithDot && `0${value}` === String(Number(value)))) pixelValue = Number(value)
					break
			}
			break
		default:
			break
	}
	if (typeof(pixelValue) !== 'number') return null
	return willIncludeUnit ? `${pixelValue}px` : pixelValue
}

// Export
export {
	convertFontSizeToPixelSize
}
